/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaching_Create_PlaceholderInputs */

const en_us2_coaching_create_placeholder = /** @type {(inputs: Coaching_Create_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E.g. Morning group`)
};

const pt_br2_coaching_create_placeholder = /** @type {(inputs: Coaching_Create_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: Turma da manhã`)
};

const pt_pt2_coaching_create_placeholder = /** @type {(inputs: Coaching_Create_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ex.: Turma da manhã`)
};

/** @type {(inputs: Coaching_Create_PlaceholderInputs) => LocalizedString} */
const es_419_coaching_create_placeholder = en_us2_coaching_create_placeholder;

/** @type {(inputs: Coaching_Create_PlaceholderInputs) => LocalizedString} */
const fr_fr2_coaching_create_placeholder = en_us2_coaching_create_placeholder;

/** @type {(inputs: Coaching_Create_PlaceholderInputs) => LocalizedString} */
const de_de2_coaching_create_placeholder = en_us2_coaching_create_placeholder;

/** @type {(inputs: Coaching_Create_PlaceholderInputs) => LocalizedString} */
const it_it2_coaching_create_placeholder = en_us2_coaching_create_placeholder;

/**
* | output |
* | --- |
* | "E.g. Morning group" |
*
* @param {Coaching_Create_PlaceholderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_create_placeholder = /** @type {((inputs?: Coaching_Create_PlaceholderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Create_PlaceholderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_create_placeholder(inputs)
	if (locale === "es-419") return es_419_coaching_create_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_create_placeholder(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_create_placeholder(inputs)
	if (locale === "de-DE") return de_de2_coaching_create_placeholder(inputs)
	if (locale === "it-IT") return it_it2_coaching_create_placeholder(inputs)
	return en_us2_coaching_create_placeholder(inputs)
});
export { coaching_create_placeholder as "coaching.create_placeholder" }